export default "__VITE_ASSET__BEXX4CuQ__"